<template>
  <div>
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
          検出
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">検出</a>
          </li>
      </ul>
    </div>
    <vcl-facebook v-if="loading"></vcl-facebook>
    <div v-else>
      <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <b-row>
            <b-col>
              <strong>検出情報</strong>
              <span class="float-right" style="font-size: 13px">検出時間 {{model.created_at | sdate}}</span>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col md="4">
              <b-form-group>
                <div class="m-1" title="" v-b-tooltip.hover>エージェント</div>
                <div title="" v-if="model && model.agent">
                  {{model.agent.name}}
                  <span v-if="model.agent.name != model.agent.host">
                    ({{model.agent.host}})
                  </span>
                </div>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <div class="m-1" title="" v-b-tooltip.hover>IPアドレス(パブリック)</div>
                <div title="" v-if="model && model.agent">{{model.agent.ip_addr_public}}</div>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <div class="m-1" title="" v-b-tooltip.hover>IPアドレス(プライベート))</div>
                <div title="" v-if="model && model.agent">{{model.agent.ip_addr_private}}</div>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <table class="text-center h5">
            <tbody class="h6">
              <tr>
                <td class="p-2">
                  <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="検出した時刻を表示">
                    検出時間
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </td>
                <td class="p-2">{{model.created_at | datetime}}</td>
              </tr>
              <tr>
                <td class="p-2">
                  <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="隔離するかどうかを表示">
                    隔離(バックアップ)
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </td>
                <td class="p-2 text-danger font-weight-bold">{{model.is_backup ? `Yes` : `No`}}</td>
              </tr>
              <tr>
                <td class="p-2">
                  <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="検出されたポリシーの分類を表示">
                    ポリシー
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </td>
                <td class="p-2">{{model && model.description ? model.description.type : '-'}}</td>
              </tr>
              <tr>
                <td class="p-2">
                  <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="検出の根拠として、検出されたポリシーのコードを表示します。">
                    検出の根拠
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </td>
                <td class="p-2">{{model && model.description ? model.description.code : '-'}}</td>
              </tr>
              <tr>
                <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="正規表現、検出時にデータを表示する URLポリシー">
                  検出データの証拠（ファイル内容）
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </span>
                <td class="p-2" v-if="model && model.description && model.description.value">{{ model.description.value || '-'}}</td>
                <td class="p-2" v-else>-</td>
              </tr>
              <tr>
                <td class="p-2">
                  <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="ファイルの検出された部分の行数を表示">
                    ライン
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </td>
                <td class="p-2" v-if="model && model.description">{{model.description.numerical > 0 ? model.description.numerical : '-'}}</td>
                <td class="p-2" v-else>-</td>
              </tr>
            </tbody>
          </table>
          <hr>
          <b-button size="sm" class="float-left" variant="info" @click="agent"> エージェントへ({{agentName}}) </b-button>
          <!-- <b-button size="sm" class="float-left ml-2" variant="info" @click="result"> 結果 </b-button> -->
          <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> 一覧 </b-button>
        </b-card>
      </b-col>
    </b-row>
    <Result v-if="model.result" :result_data="model.result" />
    </div>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
